import { ChangeObject, diffArrays } from 'diff';

function arrayDiff<T>({
  oldValue = [],
  newValue = [],
}: {
  oldValue?: T[];
  newValue?: T[];
}) {
  const diff: ChangeObject<T[]>[] = diffArrays(oldValue, newValue, {
    comparator: (a, b) => {
      if (typeof a === 'object' || typeof b === 'object') {
        return JSON.stringify(a) === JSON.stringify(b);
      }
      return a === b;
    },
  });
  const addedValues: T[] = [];
  const removedValues: T[] = [];
  for (let j = 0; j < diff.length;) {
    if (diff[j].added) {
      addedValues.push(...diff[j].value);
    }
    if (diff[j].removed) {
      removedValues.push(...diff[j].value);
    }
    j += 1;
  }
  return {
    hasChanged: removedValues.length > 0 || addedValues.length > 0,
    oldValue: removedValues,
    newValue: addedValues,
  };
}

export default arrayDiff;
